import { gql } from 'graphql.macro';

export const deleteFileTemplate = gql`
    mutation deleteFile($_id: MongoDbObjectId!, $orderId: String) {
        deleteFile(_id: $_id, orderId: $orderId)
    }
`;
